import { render, staticRenderFns } from "./FormQuestionsPage.vue?vue&type=template&id=6fc83872"
import script from "./FormQuestionsPage.vue?vue&type=script&lang=js"
export * from "./FormQuestionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc83872')) {
      api.createRecord('6fc83872', component.options)
    } else {
      api.reload('6fc83872', component.options)
    }
    module.hot.accept("./FormQuestionsPage.vue?vue&type=template&id=6fc83872", function () {
      api.rerender('6fc83872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormApp/FormQuestionsPage.vue"
export default component.exports